module.exports = __webpack_public_path__ + "static/media/sharebtn@2x.8215a4a5.png";